export default "__VITE_ASSET__EPb7fucv__"